import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const SendButton = ({ disabled }) => {
	return (
		<div id="messageSide">
			<button disabled={disabled} type="submit" value="Envoyer" className="sendButton orange send-message">
				<svg className="svgSendButton" width="16" height="16" viewBox="0 0 20 21"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M11.585 17.1666C11.467 17.1666 11.3514 17.1338 11.251 17.0718C11.1506 17.0098 11.0694 16.9212 11.0165 16.8158L9.13237 13.0456C9.08155 12.9437 9.05896 12.83 9.06696 12.7164C9.07495 12.6028 9.11323 12.4934 9.17782 12.3996L12.2201 8.27853L8.09908 11.3196C8.00539 11.3842 7.89609 11.4225 7.78257 11.4305C7.66905 11.4385 7.55547 11.4159 7.45365 11.3651L3.68229 9.4809C3.57194 9.42529 3.48021 9.33869 3.41835 9.23173C3.35648 9.12476 3.32716 9.00207 3.33398 8.87869C3.34079 8.75531 3.38346 8.6366 3.45674 8.5371C3.53001 8.4376 3.63072 8.36164 3.74653 8.31853L15.8097 3.87265C15.9235 3.8306 16.0469 3.82205 16.1654 3.84802C16.2839 3.87399 16.3925 3.93338 16.4783 4.01916C16.5641 4.10494 16.6234 4.21351 16.6494 4.33201C16.6754 4.45051 16.6668 4.57397 16.6248 4.68777L12.1795 16.7515C12.1367 16.8677 12.0608 16.9688 11.9612 17.0424C11.8616 17.116 11.7426 17.1587 11.6189 17.1654L11.585 17.1666Z"/>
				</svg>
				Envoyer
			</button>
		</div>
	);
};

SendButton.propTypes = {
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default SendButton;